module.exports = __webpack_public_path__ + "img/fanan.b4973fa7.png";